module.exports = __webpack_public_path__ + "img/Wagon_Side_Left.809a2366.svg";